var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationLeftArrowDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30452",
    "data-name": "Group 30452",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.453,
    height: 16.561,
    viewBox: "0 0 18.453 16.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17472",
    "data-name": "Path 17472",
    d: "M14.615,0,8.28,6.321,1.946,0,0,1.946l8.28,8.28,8.28-8.28Z",
    transform: "translate(18.453) rotate(90)",
    fill: "#6e7987"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17596",
    "data-name": "Path 17596",
    d: "M14.615,0,8.28,6.321,1.946,0,0,1.946l8.28,8.28,8.28-8.28Z",
    transform: "translate(10.226 0) rotate(90)",
    fill: "#6e7987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeftArrowDisable);
export default __webpack_public_path__ + "static/media/paginationLeftArrowDisable.26cb4862eaebdb8873a49882fe6236a4.svg";
export { ForwardRef as ReactComponent };